import backendInstance from './axiosInstance';
import { AUTH_URLS } from '../common/AppConstants';
import logger from '../logger';

const setupAxiosInterceptors = (refreshToken) => {
  const accessToken = localStorage.getItem('accessToken');
  // const backupToken = localStorage.getItem('backupToken');
  // console.log(`Token is = ${accessToken}`);
  if (accessToken !== null && accessToken !== undefined && accessToken !== "undefined") {
    backendInstance.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
  }
  else {
    delete backendInstance.defaults.headers.common['Authorization'];
  }

  backendInstance.interceptors.request.use(
    (config) => {
      // Log the headers of every request
      logger.log('Request url :', config.url);
      // logger.log(config.headers);

      // You can also modify the request config here if needed
      // const current_org = account?.user?.current_org;
      // const method = config.method?.toLowerCase();
      // if (['post', 'put', 'patch'].includes(method)) {
      //   // Only modify if the request has a data body (POST/PUT/PATCH)
      //   config.data = {
      //     ...(config.data || {}),
      //     organization: current_org, // inject organization = current_org
      //   };
      // }

      return config;
    },
    (error) => {
      // Do something with request error
      return Promise.reject(error);
    },
  );

  backendInstance.interceptors.response.use(
    (response) => response, // On success retun the response as it is
    async (error) => {
      // Handle errors
      const originalRequest = error.config;

      if (!originalRequest) {
        return Promise.reject(error);
      }

      const httpStatus = error.response?.status;
      const errorCode = error.response?.data?.code;

      logger.log('Response url :', originalRequest.url);
      logger.log(originalRequest);
      logger.log('originalRequest._retry', originalRequest._retry);

      // Case 1: User not found -> force logout
      if (
        httpStatus === 401 &&
        !originalRequest._retry &&
        errorCode === "user_not_found"
      ) {
        window.location.href = '/sign-out';
        return Promise.reject(error);
      }

      // Case 2: Try refresh token
      const isAuthUrl = [AUTH_URLS.REFRESH_TOKEN, AUTH_URLS.EXPIRE_TOKEN]
        .some(url => originalRequest.url?.includes(url));

      if (
        httpStatus === 401 &&
        !originalRequest._retry &&
        !isAuthUrl
      ) {
        originalRequest._retry = true;  // Marking the request to avoid infinite loop

        try {
          const newToken = await refreshToken();

          if (newToken !== null && newToken !== undefined && newToken !== "undefined") {
            logger.log('Retrying url :', originalRequest.url);
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            return backendInstance(originalRequest);
          } else {
            window.location.href = '/sign-out';
            return Promise.reject(error);
          }
        } catch (e) {
          window.location.href = '/sign-out';
          return Promise.reject(e);
        }
      }

      logger.log('Rejecting retry for url :', originalRequest.url);
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
